import {stage} from '../stage';

// FNP-909: the default Amplify GraphQL endpoint for the whole console app.
// This is `flexinet-console-api` — the API that hosts the Applications module.
//
// It was previously named `platformAPI` and every stage pointed at an API id
// that exists in NO shared-services account (verified 2026-08-12 with
// `aws appsync get-graphql-api` against dev, test and prod — all three
// returned not-found). They are dead references to deleted APIs, not a
// different live service, so repointing them breaks nothing that works today.
//
// Values below are the live `uris.GRAPHQL` of `flexinet-console-api` in each
// shared-services account, read from `aws appsync list-graphql-apis`. Note the
// endpoint host is NOT the apiId — always compare the full GRAPHQL uri when
// re-verifying, never an id substring.
//
// This is the FNP-204 defect recurring: that ticket fixed the dev endpoint
// once, and it has drifted again. If this bites a third time, add a synth- or
// CI-time assertion that each entry matches the deployed API for its account.
const consoleAPI = {
    prod: {
        // flexi-shared-svcs-prod (477488528677)
        endpoint: 'https://f3lssqzzmbd6vfegfduj5ebmye.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        apiKey: '',
    },
    test: {
        // flexi-shared-svcs-test (951377762314)
        endpoint: 'https://x2tksew75nbnja3x7yuvmlv6pe.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        apiKey: '',
    },
    dev: {
        // flexi-shared-svcs-dev (152633770454)
        endpoint: 'https://bbaseq6utvbztehupw2byq3eme.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        apiKey: '',
    },
    ide: {
        // Local dev server runs against the dev API.
        endpoint: 'https://bbaseq6utvbztehupw2byq3eme.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        apiKey: '',
    },
};

export const appSyncConfig = consoleAPI[stage];

